import styled from "styled-components";

import { v } from "constants/css";

export const SwitcherIcon = styled.span`
  width: ${v.gUnitTriple};
  height: ${v.gUnitTriple};
`;
